import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { Studio3D } from './babylonjs/Studio'
import VRStudio from './babylonjs/VrStudio'

const Main = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* The Switch decides which component to show based on the current URL.*/}
        <Route path="/" element={<Studio3D />}></Route>
        <Route path="/vr" element={<VRStudio />}></Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Main
